<template>
  <div>
    <b-table
      :items="califications"
      :fields="fields"
      :busy="isLoading"
      class="col-12 mt-2 table-views"
      show-empty
    >
      <template #empty>
        <div class="text-center my-2">
          <h2>No hay Calificiones registradas</h2>
        </div>
      </template>
      <template #cell(claim_type_related)="data">
        {{ data.item?.claim_type_related?.info }}
      </template>
      <template #cell(responsible)="data">
        {{ data.item?.responsible_entity_related?.info }}
      </template>
      <template #cell(status)="data">
        {{ data.item?.qualification_status_related?.info }}
      </template>
      <template #cell(medical_improvement)="data">
        {{ data.item?.medical_improvement ? "Si" : "No" }}
      </template>
      <template #cell(options)="row">
        <button
          class="button-table-employee"
          :id="`tooltip-button-ver-${row.item?.id}`"
          @click.prevent="findItem(row.item?.id)"
        >
          <img
            class="centerImg1 resaltar"
            :src="require('@/assets/images/icons/eye-line.svg')"
          />
        </button>

        <button
          class="button-table-employee"
          @click.prevent="editItem(row.item?.id)"
          :id="`tooltip-button-edit-${row.item?.id}`"
        >
          <span class="icon-pencil centerImg1 resaltar"> </span>
        </button>

        <button
          class="button-table-employee"
          :id="`tooltip-button-delete-${row.item.id}`"
          @click.prevent="deleteItem(row.item.id)"
        >
          <img
            class="centerImg1 resaltar icondelete"
            :src="require('@/assets/images/icons/delete-bin-2-line.svg')"
          />
        </button>

        <b-tooltip
          :target="`tooltip-button-ver-${row.item.id}`"
          placement="top"
          custom-class="custom-tooltip-ht"
        >
          Ver Calificación
        </b-tooltip>
        <b-tooltip
          :target="`tooltip-button-edit-${row.item.id}`"
          placement="top"
          custom-class="custom-tooltip-ht"
        >
          Editar Calificación
        </b-tooltip>
        <b-tooltip
          :target="`tooltip-button-delete-${row.item.id}`"
          placement="top"
          custom-class="custom-tooltip-ht"
        >
          Eliminar Calificación
        </b-tooltip>
      </template>
      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <overlay-button></overlay-button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import Pagination from "laravel-vue-pagination";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

export default {
  components: {
    Pagination,
    OverlayButton,
  },
  props: {
    califications: Array,
    isLoading: Boolean,
  },
  data() {
    return {
      fields: [
        {
          label: "Siniestro",
          key: "claim_type_related",
        },
        {
          label: "Fecha de Calificación",
          key: "qualification_date",
        },
        {
          label: "Fecha de Estructuración",
          key: "structuring_date",
        },
        {
          label: "Ente responsable",
          key: "responsible",
        },
        {
          label: "Mejoría médica máxima",
          key: "medical_improvement",
        },
        {
          label: "Estado",
          key: "status",
        },
        {
          label: "",
          key: "options",
        },
      ],
    };
  },
  computed: {
    employeeId() {
      return parseInt(this.$route.params.employee_id || "0");
    },
    diagnosticId() {
      return parseInt(this.$route.params.diagnostic_id || "0");
    },
  },
  methods: {
    findItem(id) {
      const me = this;
      me.$router.push({
        name: "detailQualification",
        params: {
          employee_id: me.employeeId,
          diagnostic_id: me.diagnosticId,
          qualitication_id: id,
          is_edit: false,
        },
      });
    },
    editItem(id) {
      const me = this;

      me.$router.push({
        name: "editQualification",
        params: {
          employee_id: me.employeeId,
          diagnostic_id: me.diagnosticId,
          qualitication_id: id,
          is_edit: true,
        },
      });
    },
    deleteItem(id) {
      const me = this;
      me.$emit("deleteItem", id);
    },
  },
};
</script>

<style lang="css">
.custom-tooltip-ht .tooltip-inner {
  max-width: 200px !important;
  background-color: #263238 !important;
  font-size: 14px !important;
}
.text-file {
  color: #1719da80;
  font-size: 16px;
  cursor: pointer;
}
</style>
